var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: _vm.title,
        width: 600,
        visible: _vm.visible,
        "cancel-text": "稍后联系",
        "ok-text": "已沟通",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      _c(
        "EmptyData",
        {
          attrs: {
            dataSource: _vm.contactList,
            loading: _vm.loading,
            "style-obj": { height: "400px" },
          },
        },
        [
          _c(
            "template",
            { slot: "content" },
            _vm._l(_vm.contactList, function (item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { padding: "10px" } },
                [
                  _c("span", { staticClass: "realname" }, [
                    _vm._v(_vm._s(item.realname) + "："),
                  ]),
                  _c("span", [_vm._v(_vm._s(item.phone))]),
                ]
              )
            }),
            0
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }